/**
 * もらったキー一覧に対して画面表示ラベルを取得する
 *
 * 例）
 *
 * values
 *
 * ```js
 * [ 'rank', 'pfv', 'age' ]
 * ```
 *
 * initialLabels
 *
 * ```js
 * {
 *   rank: 'ロイヤル',
 *   pfv: 'PFV',
 *   age: '年代'
 * }
 * ```
 *
 * envKey
 *
 * ```
 * VUE_APP_LABEL_CUSTOMER_SEGMENT
 * ```
 *
 * .env
 *
 * ```
 * VUE_APP_LABEL_CUSTOMER_SEGMENT_RANK=顧客ランク
 * VUE_APP_LABEL_CUSTOMER_SEGMENT_PFV=顧客PFV
 * ```
 *
 * Returns
 *
 * ```js
 * {
 *   rank: '顧客ランク',
 *   pfv: '顧客PFV',
 *   age: '年代'
 * }
 * ```
 *
 * @param {Array<String>} values ラベルを検索するキーリスト
 * @param {Object} initialLabels envに定義されていない場合の初期値
 * @param {String} envKey envから探す際のキー（接頭辞）
 */
export function getLabels(values, initialLabels, envKey) {
  const ret = {}

  values.forEach(v => {
    ret[v] = process.env[`${envKey}_${v.toUpperCase()}`] || initialLabels[v]

    if (process.env.NODE_ENV === 'development') {
      if (!ret[v]) {
        throw new Error(
          `ラベルが見つかりません(${v})。初期値の設定を忘れていませんか？`,
        )
      }
    }
  })

  return ret
}
